import React, { FC } from 'react';
import { View } from 'react-native';

import { AssessmentData } from './ContainAssessment';
import { BloomFlower } from '../ui/BloomFlower';
import { Body1Reg, Title2, Title3 } from '../../../config/designSystem/typography';
import { COLORS } from '../../../config/designSystem/Colors';
import { GradientSlider } from '../ui/GradientSlider';
import { QuestionSessionBodyPresentationProps } from '../../QuestionSessions/QuestionSessionBody/config';
import { SPACING } from '../../../config/designSystem/Spacing';
import { useDiaryMaxWidth } from '../ui/useDiaryMaxWidth';

/**
 * figma: Journaling/Assessment pt.1 (Activities & Challenges pt1)
 * "How was your sleep last night?" / "How are you today?": a blooming flower
 * mirroring the rating and a gradient slider between the two extreme labels.
 */
export const PresentAssessment: FC<QuestionSessionBodyPresentationProps> = ({
  questionText,
  data,
}) => {
  const maxWidth = useDiaryMaxWidth();
  const { scale, value, onChangeValue, gradient } = (data || {}) as AssessmentData;

  if (!scale || !gradient) {
    return null;
  }

  const steps = Math.max(scale.length, 2);
  const bloom = steps > 1 ? value / (steps - 1) : 1;

  return (
    <View style={{ flex: 1, alignItems: 'center', paddingHorizontal: SPACING['sp-16'] }}>
      <View
        style={{
          flex: 1,
          width: '100%',
          maxWidth,
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingTop: SPACING['sp-24'],
          paddingBottom: SPACING['sp-64'],
        }}
      >
        <Title2 align={true}>{questionText}</Title2>
        <BloomFlower
          bloom={bloom}
          petalColor={gradient.base.right}
          rayColor={gradient.dark.left}
        />
        <View style={{ width: '100%', rowGap: SPACING['sp-16'], alignItems: 'center' }}>
          <Title3 align={true}>{scale[value] || ''}</Title3>
          <GradientSlider
            value={value}
            steps={steps}
            onChange={onChangeValue}
            gradient={gradient.base}
          />
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
            <Body1Reg color={COLORS.content.primary}>{scale[0] || ''}</Body1Reg>
            <Body1Reg color={COLORS.content.primary}>{scale[steps - 1] || ''}</Body1Reg>
          </View>
        </View>
      </View>
    </View>
  );
};
